module.exports = __webpack_public_path__ + "static/media/ICT-8.a6d4224e.png";